// extracted by mini-css-extract-plugin
export default {"dialogContent":"style--dialogContent--4c30ed"};